import { Navigate } from 'react-router-dom';
import { useAdmin } from '../contexts/AdminContext';
import LoadingSpinner from './LoadingSpinner';

/**
 * SmartRedirect - Redirects admin to their first allowed section based on privileges
 * If admin has social privileges, renders children (Dashboard)
 * If admin only has basketball privileges, redirects to basketball section
 */
export default function SmartRedirect({ children }) {
    const { admin, isLoading, hasPrivilege } = useAdmin();

    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <LoadingSpinner size="large" />
            </div>
        );
    }

    if (!admin) {
        return <Navigate to="/unauthorized" replace />;
    }

    // Check if admin has any social platform privileges
    const hasSocialPrivilege =
        hasPrivilege('user_management') ||
        hasPrivilege('content_moderation') ||
        hasPrivilege('verification_approval') ||
        hasPrivilege('analytics_view') ||
        hasPrivilege('system_config') ||
        hasPrivilege('notification_management');

    // Social platform privileges get Dashboard
    if (hasSocialPrivilege) {
        return children;
    }

    // Basketball-only admins go to basketball section
    if (hasPrivilege('basketball_management')) {
        return <Navigate to="/basketball/games" replace />;
    }

    // Fallback - should not happen if admin has at least one privilege
    return <Navigate to="/unauthorized" replace />;
}

